import React, { ChangeEvent, useEffect, useState } from 'react';
import api from '../../services/api';
import { createComment } from '../../hooks/conversation';
import { renderError } from '../../hooks/error';
import { showMessage } from '../../hooks/messages';
import {
  Container,
  Title,
  FirstComment,
  Frame,
  Comment,
  MadeBy,
  Text,
  SecondComment,
  Button,
  ButtonDocument,
} from './styles';
import TextArea from '../TextArea';

interface CommentProps {
  id: number;
  id_user: {
    name: string;
  };
  created_at: string;
  text: string;
}
export type ConversartionProps = {
  essay: number;
};

export const Conversation = ({ essay }: ConversartionProps) => {
  const [comments, setComments] = useState<CommentProps[]>([]);
  const [comment, setComment] = useState('');

  const changeParagraph = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setComment(event.target.value);
  };

  const verifyExistsComments = async () => {
    try {
      const response = await api.get(
        `/essay-conversations?_sort=created_at&id_essay=${essay}`
      );
      setComments(response.data);
    } catch (err) {
      renderError(err);
    }
  };

  useEffect(() => {
    api
      .get(`/essay-conversations?_sort=created_at&id_essay=${essay}`)
      .then(({ data }) => {
        setComments(data);
      });
  }, [essay]);

  const submit = async () => {
    if (comment.length) {
      const response = await createComment(essay, comment);
      comments.push(response);
      setComment('');
      verifyExistsComments();
    } else {
      showMessage({
        intent: 'error',
        message: 'Digite a mensagem na área de comentários.',
      });
    }
  };

  return (
    <Container>
      <Title>
        <h2>Comentários</h2>
        <hr />
      </Title>
      {comments.map((comment: CommentProps, index: number) => (
        <div key={index + new Date().getTime()}>
          {index === 0 && (
            <FirstComment>
              <Frame>
                <svg>
                  <path d="M26.854 21.5837C28.1727 20.1675 28.9156 18.3103 28.9373 16.3753C28.9373 14.2867 28.1077 12.2837 26.6308 10.8069C25.154 9.33001 23.1509 8.50033 21.0623 8.50033C18.9738 8.50033 16.9707 9.33001 15.4939 10.8069C14.017 12.2837 13.1873 14.2867 13.1873 16.3753C13.2091 18.3103 13.952 20.1675 15.2707 21.5837C13.4345 22.498 11.8545 23.8544 10.6726 25.5308C9.49069 27.2073 8.74406 29.1512 8.49984 31.1878C8.43906 31.7404 8.60026 32.2944 8.94799 32.7281C9.29571 33.1618 9.80147 33.4395 10.354 33.5003C10.9065 33.5611 11.4606 33.3999 11.8943 33.0522C12.3279 32.7045 12.6057 32.1987 12.6665 31.6462C12.9151 29.6277 13.8933 27.7698 15.4167 26.4225C16.9401 25.0752 18.9036 24.3315 20.9373 24.3315C22.9711 24.3315 24.9346 25.0752 26.458 26.4225C27.9814 27.7698 28.9596 29.6277 29.2082 31.6462C29.2661 32.1804 29.5282 32.6715 29.9397 33.017C30.3512 33.3625 30.8803 33.5357 31.4165 33.5003H31.6457C32.1918 33.4375 32.6909 33.1614 33.0343 32.7321C33.3778 32.3028 33.5376 31.7553 33.479 31.2087C33.2529 29.1828 32.5298 27.2441 31.374 25.565C30.2183 23.8859 28.6656 22.5182 26.854 21.5837ZM20.9998 20.0837C20.2664 20.0837 19.5494 19.8662 18.9396 19.4587C18.3298 19.0512 17.8545 18.4721 17.5738 17.7944C17.2931 17.1168 17.2197 16.3712 17.3628 15.6519C17.5058 14.9325 17.859 14.2718 18.3777 13.7531C18.8963 13.2345 19.557 12.8813 20.2764 12.7382C20.9957 12.5952 21.7413 12.6686 22.419 12.9493C23.0966 13.2299 23.6757 13.7053 24.0832 14.3151C24.4907 14.9249 24.7082 15.6419 24.7082 16.3753C24.7082 17.3588 24.3175 18.3021 23.622 18.9975C22.9266 19.693 21.9834 20.0837 20.9998 20.0837ZM35.5832 0.166992H6.4165C4.7589 0.166992 3.16919 0.825473 1.99709 1.99758C0.824984 3.16968 0.166504 4.75939 0.166504 6.41699V35.5837C0.166504 37.2413 0.824984 38.831 1.99709 40.0031C3.16919 41.1752 4.7589 41.8337 6.4165 41.8337H35.5832C37.2408 41.8337 38.8305 41.1752 40.0026 40.0031C41.1747 38.831 41.8332 37.2413 41.8332 35.5837V6.41699C41.8332 4.75939 41.1747 3.16968 40.0026 1.99758C38.8305 0.825473 37.2408 0.166992 35.5832 0.166992ZM37.6665 35.5837C37.6665 36.1362 37.447 36.6661 37.0563 37.0568C36.6656 37.4475 36.1357 37.667 35.5832 37.667H6.4165C5.86397 37.667 5.33407 37.4475 4.94337 37.0568C4.55266 36.6661 4.33317 36.1362 4.33317 35.5837V6.41699C4.33317 5.86446 4.55266 5.33455 4.94337 4.94385C5.33407 4.55315 5.86397 4.33366 6.4165 4.33366H35.5832C36.1357 4.33366 36.6656 4.55315 37.0563 4.94385C37.447 5.33455 37.6665 5.86446 37.6665 6.41699V35.5837Z"></path>
                </svg>
              </Frame>

              <Comment>
                <MadeBy>{comment.id_user.name}</MadeBy>
                <Text>{comment.text}</Text>
              </Comment>
            </FirstComment>
          )}
          {index !== 0 && (
            <SecondComment key={index + 1 + new Date().getTime()}>
              <Frame>
                <svg>
                  <path d="M26.854 21.5837C28.1727 20.1675 28.9156 18.3103 28.9373 16.3753C28.9373 14.2867 28.1077 12.2837 26.6308 10.8069C25.154 9.33001 23.1509 8.50033 21.0623 8.50033C18.9738 8.50033 16.9707 9.33001 15.4939 10.8069C14.017 12.2837 13.1873 14.2867 13.1873 16.3753C13.2091 18.3103 13.952 20.1675 15.2707 21.5837C13.4345 22.498 11.8545 23.8544 10.6726 25.5308C9.49069 27.2073 8.74406 29.1512 8.49984 31.1878C8.43906 31.7404 8.60026 32.2944 8.94799 32.7281C9.29571 33.1618 9.80147 33.4395 10.354 33.5003C10.9065 33.5611 11.4606 33.3999 11.8943 33.0522C12.3279 32.7045 12.6057 32.1987 12.6665 31.6462C12.9151 29.6277 13.8933 27.7698 15.4167 26.4225C16.9401 25.0752 18.9036 24.3315 20.9373 24.3315C22.9711 24.3315 24.9346 25.0752 26.458 26.4225C27.9814 27.7698 28.9596 29.6277 29.2082 31.6462C29.2661 32.1804 29.5282 32.6715 29.9397 33.017C30.3512 33.3625 30.8803 33.5357 31.4165 33.5003H31.6457C32.1918 33.4375 32.6909 33.1614 33.0343 32.7321C33.3778 32.3028 33.5376 31.7553 33.479 31.2087C33.2529 29.1828 32.5298 27.2441 31.374 25.565C30.2183 23.8859 28.6656 22.5182 26.854 21.5837ZM20.9998 20.0837C20.2664 20.0837 19.5494 19.8662 18.9396 19.4587C18.3298 19.0512 17.8545 18.4721 17.5738 17.7944C17.2931 17.1168 17.2197 16.3712 17.3628 15.6519C17.5058 14.9325 17.859 14.2718 18.3777 13.7531C18.8963 13.2345 19.557 12.8813 20.2764 12.7382C20.9957 12.5952 21.7413 12.6686 22.419 12.9493C23.0966 13.2299 23.6757 13.7053 24.0832 14.3151C24.4907 14.9249 24.7082 15.6419 24.7082 16.3753C24.7082 17.3588 24.3175 18.3021 23.622 18.9975C22.9266 19.693 21.9834 20.0837 20.9998 20.0837ZM35.5832 0.166992H6.4165C4.7589 0.166992 3.16919 0.825473 1.99709 1.99758C0.824984 3.16968 0.166504 4.75939 0.166504 6.41699V35.5837C0.166504 37.2413 0.824984 38.831 1.99709 40.0031C3.16919 41.1752 4.7589 41.8337 6.4165 41.8337H35.5832C37.2408 41.8337 38.8305 41.1752 40.0026 40.0031C41.1747 38.831 41.8332 37.2413 41.8332 35.5837V6.41699C41.8332 4.75939 41.1747 3.16968 40.0026 1.99758C38.8305 0.825473 37.2408 0.166992 35.5832 0.166992ZM37.6665 35.5837C37.6665 36.1362 37.447 36.6661 37.0563 37.0568C36.6656 37.4475 36.1357 37.667 35.5832 37.667H6.4165C5.86397 37.667 5.33407 37.4475 4.94337 37.0568C4.55266 36.6661 4.33317 36.1362 4.33317 35.5837V6.41699C4.33317 5.86446 4.55266 5.33455 4.94337 4.94385C5.33407 4.55315 5.86397 4.33366 6.4165 4.33366H35.5832C36.1357 4.33366 36.6656 4.55315 37.0563 4.94385C37.447 5.33455 37.6665 5.86446 37.6665 6.41699V35.5837Z"></path>
                </svg>
              </Frame>
              <Comment>
                <MadeBy>{comment.id_user.name}</MadeBy>
                <Text>{comment.text}</Text>
              </Comment>
            </SecondComment>
          )}
        </div>
      ))}

      <Button>
        <TextArea
          isGreyScale={false}
          placeholder="Responda ao comentário do seu aluno"
          labelText="Resposta"
          change={changeParagraph}
          value={comment}
        />
        <button
          type="button"
          onClick={() => {
            submit();
          }}
        >
          <ButtonDocument>
            Enviar
            <svg>
              <path d="M20.909,9.961,9.7,3.533A3.968,3.968,0,0,0,3.75,7.014v12.9A3.965,3.965,0,0,0,9.7,23.35l11.208-6.428a3.968,3.968,0,0,0,0-6.868Zm-1.16,4.861L8.542,21.343a1.671,1.671,0,0,1-1.647,0,1.648,1.648,0,0,1-.824-1.427V6.968A1.648,1.648,0,0,1,6.894,5.54a1.752,1.752,0,0,1,.823-.22,1.787,1.787,0,0,1,.824.22l11.208,6.474a1.648,1.648,0,0,1,0,2.854Z" />
            </svg>
          </ButtonDocument>
        </button>
      </Button>
    </Container>
  );
};

export default Conversation;
